import React, { ReactNode } from "react";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";

// The cookie banner is served by CookieYes via Google Tag Manager.
const wrapRootElement = ({ element }: { element: ReactNode }) => (
  <ThemeProvider theme={theme}>{element}</ThemeProvider>
);

export default wrapRootElement;
